export const createGetUserDashboardCardsRequest = () => {
    return {
        url: "/dashboard/cards",
        method: "GET",
    }
}